import { TEMPLATE_TYPES, TEMPLATES } from "utils/constants";
import AdherentBirthDate from "./AdherenBirthdate";
import AdherentBirthDateRenaultSalary from "./AdherenBirthdateRenault";
import AdherentInfo from "./AdherentInfo";
import AdherentTelecoms from "./AdherentTelecoms";
import BankInformation from "./BankInformation";
import ChildrenJustification from "./ChildrenJustification";
import Loading from "./Components/Loader";
import Default from "./Default";
import EffectiveDate from "./EffectiveDate";
import ElectronicSignature from "./ESign";
import GenerateESignDocuments from "./GenerateESignDocuments";
import Justification from "./Justification";
import Needs from "./Needs";
import Products from "./Products";
import RelatedPersons from "./RelatedPersons";
import SocialSecurityNumber from "./SocialSecurityNumber";
import SpouseJustification from "./SpouseJustification";
import SubscriptionDone from "./SubscriptionDone";
import Upsells from "./Upsells";

const Templates = {
  Loading: <Loading />,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY].ADHERENT_BIRTHDATE]:
    AdherentBirthDate,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY]
    .ADHERENT_BIRTHDATE_RENAULT_EMPLOYEE]: AdherentBirthDateRenaultSalary,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY].NEEDS]: Needs,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY].ADHERENT_INFO]:
    AdherentInfo,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY].PRODUCTS]: Products,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY].EFFECTIVE_DATE]:
    EffectiveDate,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY].ADHERENT_TELECOMS]:
    AdherentTelecoms,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY]
    .ADHERENT_SOCIAL_SECURITY_NUMBER]: SocialSecurityNumber,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY].RELATED_PERSONS]:
    RelatedPersons,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY]
    .ADHERENT_BANK_INFORMATION]: BankInformation,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY]
    .GENERATE_E_SIGN_DOCUMENTS]: GenerateESignDocuments,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY].E_SIGN]:
    ElectronicSignature,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY].JUSTIFICATIONS]:
    Justification,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY]
    .SPOUSE_JUSTIFICATIONS]: SpouseJustification,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY]
    .CHILDREN_JUSTIFICATIONS]: ChildrenJustification,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY].UPSELLS]: Upsells,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY].SUBSCRIPTION_DONE]:
    SubscriptionDone,
  default: Default,
};
export default Templates;
